import React, { useState } from "react";
import { RegInput } from "valuations-journey";
import { PageLayout } from "../../components";
import { useSourceSystem } from "../../hooks/useSourceSystem";

export default function RegistrationInput({
  onSubmit,
  error,
  showPrivacyStatement
}) {
  const [reg, setReg] = useState("");
  const {
    sourceSystem: { getCTAValue }
  } = useSourceSystem();
  const CTALabel = getCTAValue && getCTAValue();

  return (
    <PageLayout>
      <PageLayout.Header title="Registration" step={1} />
      <PageLayout.Content>
        <div className="registration-input">
          <p className="ch-fs--4" >
            Let&#39;s start with your registration plate
          </p>
          <RegInput
            onChange={(e) => setReg(e.target.value)}
            value={reg}
            error={error}
            title="Registration"
            placeholder="Enter reg"
          />
        </div>
        {showPrivacyStatement && (
          <p className="ch-text--center ch-mt--4 ch-fs--2">
            Your information will only be used for the purposes of the valuation
            and you can refer to our{" "}
            <a
              href="https://www.arnoldclark.com/cookies/"
              target="_blank"
              rel="noopener noreferrer"
            >
              privacy policy
            </a>{" "}
            for more details.
          </p>
        )}
      </PageLayout.Content>
      <PageLayout.Footer>
        <button
          className="ch-btn ch-btn--success ch-display--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
          type="button"
          onClick={() => onSubmit(reg)}
        >
          {CTALabel}
        </button>
      </PageLayout.Footer>
    </PageLayout>
  );
}
